import Swiper from 'swiper/bundle';

const sliderLogo = () => {
    const swiper = new Swiper(".js-logo-slider", {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesPerGroup: 2,
        loop: true,
        navigation: {
            nextEl: '.logo-slider-next',
            prevEl: '.logo-slider-prev',
        },
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
                slidesPerGroup: 2,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 20,
                slidesPerGroup: 4,
            },
            1024: {
                slidesPerView: 6,
                spaceBetween: 20,
                slidesPerGroup: 6,
            },
        },
    });
}


export default sliderLogo